import { render, staticRenderFns } from "./sAgriculturalFarmResponsibleCollecting.vue?vue&type=template&id=177730ec"
import script from "./sAgriculturalFarmResponsibleCollecting.vue?vue&type=script&lang=js"
export * from "./sAgriculturalFarmResponsibleCollecting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports